/* ============================================================
   MORVEN QUICK VIEW, DESCRIPTION READ MORE

   Why this is a separate asset and not a script inside the quick
   view template: the quick view drawer is fetched and injected into
   the page as HTML, and script tags inserted that way never execute.
   The product page's own read more script therefore cannot be reused
   in place. This file is loaded once in the head on every page from
   snippets/morven-variant-picker.liquid, and watches for the drawer
   arriving instead of waiting for a load event that never fires.

   The line count is read from the --morven-qv-desc-lines custom
   property in morven-quick-view.css, so the CSS stays the single
   place that decides how much text shows.
   ============================================================ */

(function () {
  'use strict';

  var SELECTOR = '.quick-view .js-quick-view-description';
  var BOUND = 'morvenQvReadMore';
  var LABEL_MORE = 'Read more';
  var LABEL_LESS = 'Read less';

  function clampLines(el) {
    var raw = window.getComputedStyle(el).getPropertyValue('--morven-qv-desc-lines');
    var n = parseInt(raw, 10);
    return (n && !isNaN(n)) ? n : 3;
  }

  function lineHeight(el) {
    var cs = window.getComputedStyle(el);
    var lh = parseFloat(cs.lineHeight);

    // line-height: normal resolves to the string, not a number.
    if (!lh || isNaN(lh)) {
      lh = parseFloat(cs.fontSize) * 1.6;
    }

    return lh || 24;
  }

  /* Returns false if the element is not laid out yet, so the caller
     can retry. The drawer animates in, and measuring a zero width
     element reports the wrong number of lines. */
  function init(el) {
    if (el.dataset[BOUND] === 'true') return true;
    if (!el.clientWidth) return false;

    el.dataset[BOUND] = 'true';

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'morven-qv-readmore';
    button.setAttribute('aria-expanded', 'false');
    button.textContent = LABEL_MORE;
    button.hidden = true;
    el.insertAdjacentElement('afterend', button);

    function collapsedHeight() {
      return lineHeight(el) * clampLines(el);
    }

    function applyState() {
      el.classList.remove('is-expanded');
      button.textContent = LABEL_MORE;
      button.setAttribute('aria-expanded', 'false');

      var collapsed = collapsedHeight();

      /* Lift the clamp before measuring. A clamped element can report
         the clamped height, which would hide the button even when
         there is more text to reveal. */
      el.style.maxHeight = 'none';
      var full = el.scrollHeight;
      el.style.maxHeight = collapsed + 'px';

      if (full <= collapsed + 1) {
        button.hidden = true;
        el.style.maxHeight = '';
        el.classList.remove('is-clamped');
        return;
      }

      el.classList.add('is-clamped');
      button.hidden = false;
    }

    button.addEventListener('click', function () {
      var expanded = el.classList.toggle('is-expanded');

      button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      button.textContent = expanded ? LABEL_LESS : LABEL_MORE;

      el.style.maxHeight = expanded
        ? el.scrollHeight + 'px'
        : collapsedHeight() + 'px';
    });

    applyState();

    window.addEventListener('resize', function () {
      if (!el.classList.contains('is-expanded')) applyState();
    });

    return true;
  }

  function run() {
    var els = document.querySelectorAll(SELECTOR);
    var pending = false;

    for (var i = 0; i < els.length; i++) {
      if (init(els[i]) === false) pending = true;
    }

    return pending;
  }

  function runWithRetry(attempt) {
    attempt = attempt || 0;

    if (run() && attempt < 20) {
      window.setTimeout(function () {
        runWithRetry(attempt + 1);
      }, 100);
    }
  }

  function start() {
    var timer = null;

    new MutationObserver(function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        runWithRetry(0);
      }, 50);
    }).observe(document.body, { childList: true, subtree: true });

    runWithRetry(0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
